import { ContentCopy } from "@mui/icons-material";
import { Box, IconButton, Paper, Tooltip, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Markdown from "react-markdown";
import { showSnackbar } from "services/snackbarHelper";
import { Message as MessageType } from "types/message";

const Message = ({ message }: { message: MessageType }) => {
	const { t } = useTranslation(["common"]);
	const theme = useTheme();

	return (
		<>
			<Paper
				className="messageBox"
				sx={{
					maxWidth: "90%",
					overflow: "hidden",
					"& *": { wordBreak: "break-word" },
					"& p": { margin: 0 },
					"& code": { textWrap: "auto" },
					position: "relative",
					bgcolor: message.status === "error" ? "error.main" : message.sentBy === "user" ? "primary.main" : "",
					color: message.sentBy === "user" ? "primary.contrastText" : "text.primary",
					py: 1,
					px: 2,
				}}>
				<Markdown
					components={{
						pre: ({ node, className, children, ...props }) => {
							if ((children as any).props.node.tagName === "code") {
								return (
									<Box
										component="pre"
										sx={{
											bgcolor: theme.palette.mode === "dark" ? "#0d0d0d" : "#333333",
											color: "white",
											padding: "8px 10px",
											borderRadius: 2,
											position: "relative",
											[`&:hover .copy`]: {
												opacity: 1,
											},
											...props,
										}}>
										<IconButton
											className="copy"
											size="small"
											onClick={() => {
												navigator.clipboard.writeText((children as any).props.children);
												showSnackbar(t("copySuccess"), "success");
											}}
											sx={{
												color: "white",
												position: "absolute",
												top: 0,
												right: 0,
												p: 1,
												opacity: 0,
												//transition: "opacity 0.2s ease-in-out",
											}}>
											<ContentCopy fontSize="small" />
										</IconButton>

										{children}
									</Box>
								);
							} else {
								return (
									<pre
										className={className}
										{...props}>
										{children}
									</pre>
								);
							}
						},
						code: ({ node, className, children, ...props }) => (
							<>
								<code
									{...props}
									style={{
										color: "white",
										backgroundColor: theme.palette.mode === "dark" ? "#0d0d0d" : "#333333",
										borderRadius: 2,
										padding: "2px 4px",
									}}>
									{children}
								</code>
							</>
						),
					}}>
					{message.message.messageContent}
				</Markdown>
				{message?.contextTitle && message.contextTitle.length > 0 && (
					<Box mt={2}>
						<h3 style={{ marginBottom: 0 }}>{t("contextReference")}</h3>
						<Box
							display="grid"
							columnGap={0.5}
							sx={{ gridTemplateColumns: "auto 1fr" }}>
							{message.contextTitle.map((title, i) => {
								return (
									<React.Fragment key={i}>
										<Typography textAlign={"justify"}>{`[${i}]`}</Typography>
										<Typography variant="body2">{title}</Typography>
									</React.Fragment>
								);
							})}
						</Box>
					</Box>
				)}
			</Paper>

			{message.sentBy === "assistant" && (
				<Box
					pt={0.5}
					display="flex"
					gap={1}>
					<Tooltip
						title={t("copy")}
						placement="top">
						<IconButton
							sx={{ color: "text.secondary" }}
							onClick={() => {
								navigator.clipboard.writeText(message.message.messageContent);
								showSnackbar(t("copySuccess"), "success");
							}}>
							<ContentCopy fontSize="small" />
						</IconButton>
					</Tooltip>
				</Box>
			)}
		</>
	);
};

export default Message;
